import { render, staticRenderFns } from "./Integrat.vue?vue&type=template&id=2ddebc96&"
import script from "./Integrat.vue?vue&type=script&lang=js&"
export * from "./Integrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports